export enum ESellerInvoiceStatus {
  OK = 'OK',
  ACPT = 'ACPT',
  RJCT = 'RJCT',
  ER = 'ER',
  PC = 'PC',
  PENDING = '',
}

export enum ESellerBillingStatus {
  PENDING = '',
  OK = 'OK',
  ACPT = 'ACPT',
  RJCT = 'RJCT',
}

export enum ESellerPaymentStatus {
  PDNG = 'PDNG',
  PACC = 'PACC',
  ACCC = 'ACCC',
  ERR = 'ERR',
  CXLD = 'CXLD',
}

export enum ESellerPaymentAutoStatus {
  PDNG = 'PDNG',
  OK = 'OK',
}
